import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';

import TableActions from 'components/layouts/table';

import EnumsDropdown from '../Dropdown';

const Tools = () => {
  const table = useTable({
    label: 'tools',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        width: 2,
        sort: true
      },
      {
        header: 'Label',
        key: 'label',
        type: 'string',
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row className="tools-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Tools"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[{ type: 'search' }]}
        />
      </Col>
      <Col xs={12}>
        <Table loader {...table} />
      </Col>
    </Row>
  );
};

export default Tools;
